import React, { FC } from 'react'
import Head from 'next/head'

type Props = {
  // 一个或多个 schema.org JSON-LD 对象
  data: Record<string, unknown> | Record<string, unknown>[]
}

const StructuredData: FC<Props> = ({ data }) => {
  const items = Array.isArray(data) ? data : [data]
  return (
    <Head>
      {items.map((item, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }} />
      ))}
    </Head>
  )
}

export default StructuredData
